import React from 'react';
import {Image, PageHeader} from 'antd';

const List = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Список"
            />
            <h3>Список - дополнительный вид для просмотра данных</h3><br/>
            <p>В режиме Списка удобно просматривать данные с телефона, как и в таблице есть кнопочка more и для администратора
                кнопочка edit,<br/>
                работают аналогично таблице, для минималистичного скролла использовалась библиотека react-custom-scrollbars</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601227508/documentation/Screenshot_2020-09-27_at_20.24.46_mpophk.png"
            /><br/><br/>
            <h3>В режиме студента доступен подробный просмотр задания по клику на кнопку more</h3><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601208548/docs/Screenshot_2020-09-27_at_15.07.06_zedq5v.png"
            /><br/><br/>
            <h3>В режиме администратора появляется дополнительная кнопка edit, по ней доступно редактирование в окне задания</h3><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601208548/docs/Screenshot_2020-09-27_at_15.07.22_gawblu.png"
            /><br/><br/>
        </>
    );
};

export default List;